<template>
  <div class="pdt-20px">
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeTlpe.infoGenerales.title')}}</p>
      </header>
      <info-generales :commande-tlpe="commandeTlpe"></info-generales>
    </div>
    <div class="section-details card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('editCommandeTlpe.collectivite.title')}}
        </p>
      </header>
      <info-collectivite :collectivite="commandeTlpe.intervenants[0]"></info-collectivite>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeTlpe.infoMateriel.title')}}</p>
      </header>
      <info-materiel :commande-tlpe="commandeTlpe"></info-materiel>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('editCommandeTlpe.infoCommentaire.title')}}</p>
      </header>
      <info-commentaires :commande-tlpe="commandeTlpe"></info-commentaires>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('piecesJointes.attachments')}}</p>
      </header>
      <div class="card-content">
        <pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import infoGenerales from '@/components/gabed/commandeTlpe/edition/infoGenerales';
import infoMateriel from '@/components/gabed/commandeTlpe/edition/infoMateriel';
import piecesJointes from '@/components/general/piecesJointes';
import infoCollectivite from '@/components/gabed/commandeTlpe/infoCollectivite';
import infoCommentaires from '@/components/gabed/commandeTlpe/edition/infoCommentaires';

export default {
  components: {
    infoGenerales,
    infoMateriel,
    infoCollectivite,
    infoCommentaires,
    piecesJointes,
  },
  props: {
    commandeTlpe: {
      required: true,
      type: Object,
    },
  },
};
</script>
